<template>
    <v-radio-group
        :id="id"
        v-model="modelValue"
        :variant="variant"
        :disabled="disabled"
        :rules="[rules.required]"
        :color="isValid ? 'success' : undefined"
        :inline="inline"
    >
        <v-radio
            v-for="option in options"
            :id="id + '_' + option.label"
            :key="option.value"
            :data-id="'radioOption_' + option.value"
            class="font-weight-bold"
            :label="option.label"
            :value="option.value"
        ></v-radio>
    </v-radio-group>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useValidation } from '../../composables';
import { IRadioGroupProps } from '../../types';

const modelValue = defineModel<string>('modelValue');

const props = withDefaults(defineProps<IRadioGroupProps>(), {
    variant: 'outlined',
    inline: false,
    disabled: false,
    options: () => []
});

const { rules, validateRules } = useValidation(props);

const isValid = computed(() => validateRules(modelValue.value));
</script>
